import {PageContentTitle} from "../../../ui";
import {
    cmsConfigurationStore,
    cmsShippingOptionStore,
    cmsStorageStore,
    growlStore,
    validationStore
} from "../../../../store";
import {observer} from "mobx-react";
import {CmsConfigurationForm} from "./CmsConfigurationForm";

const CmsConfigurationPage = observer(function () {
    const {
        dirty,
        valid,
        saving
    } = cmsConfigurationStore
    const display = 'Konfiguration'
    return <>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${saving ? 'is-loading' : ''}`,
                    disabled: !(dirty) || !valid,
                    action: async () => {
                        await cmsConfigurationStore.save()
                        cmsConfigurationStore.reset()
                        growlStore.add({
                            message: 'Der Kunde wurde erfolgreich gespeichert',
                            autoclose: true,
                            closable: true
                        })
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: saving || !dirty,
                    action: async () => {
                        cmsConfigurationStore.reset()
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <CmsConfigurationForm
            onChange={value => {
                cmsConfigurationStore.storageWarehouseId = value.storageWarehouseId
                cmsConfigurationStore.storageCabinets = value.storageCabinets
                cmsConfigurationStore.fulfilmentMaximumVehiclesPerDeliveryMethod = value.fulfilmentMaximumVehiclesPerDeliveryMethod
                cmsConfigurationStore.statisticsConfiguration = value.statisticsConfiguration
                cmsConfigurationStore.accountingConfiguration = value.accountingConfiguration
                cmsConfigurationStore.shippingConfigurationFormData = value.shippingOptionConfiguration
                cmsConfigurationStore.shipmentReadyConfiguration = value.shipmentReadyConfiguration
            }}
            saving={cmsConfigurationStore.saving}
            loading={cmsConfigurationStore.loading}
            validate={async () => await cmsConfigurationStore.validate()}
            storageWarehouseOption={cmsStorageStore.warehouseOptions}
            shippingClientOptions={cmsShippingOptionStore.selectClientOptions}
            validationFor={(k: string) => validationStore.getFor(k)}
            help={{
                storageWarehouseId: validationStore.getFor('storageWarehouseId'),
                storageCabinets: validationStore.getFor('storageCabinets'),
                accountingConfiguration: {
                    vkBur: validationStore.getFor('accountingConfiguration.vkBur'),
                    vkOrg: validationStore.getFor('accountingConfiguration.vkOrg')
                },
                fulfilmentMaximumVehiclesPerDeliveryMethod: {
                    lateMorning: validationStore.getFor('fulfilmentMaximumVehiclesPerDeliveryMethod.lateMorning'),
                    morning: validationStore.getFor('fulfilmentMaximumVehiclesPerDeliveryMethod.morning'),
                    noon: validationStore.getFor('fulfilmentMaximumVehiclesPerDeliveryMethod.noon'),
                    post: validationStore.getFor('fulfilmentMaximumVehiclesPerDeliveryMethod.post'),
                    tracked: validationStore.getFor('fulfilmentMaximumVehiclesPerDeliveryMethod.tracked'),
                },
                statisticsConfigurationDto: {
                    slaEndOfWorkday: validationStore.getFor('statisticsConfiguration.slaEndOfWorkday'),
                },
            }}
            value={{
                storageWarehouseId: cmsConfigurationStore.storageWarehouseId || '',
                storageCabinets: cmsConfigurationStore.storageCabinets || [],
                accountingConfiguration: cmsConfigurationStore.accountingConfiguration || {},
                fulfilmentMaximumVehiclesPerDeliveryMethod: cmsConfigurationStore.fulfilmentMaximumVehiclesPerDeliveryMethod || {},
                statisticsConfiguration: cmsConfigurationStore.statisticsConfiguration || {},
                shipmentReadyConfiguration: cmsConfigurationStore.shipmentReadyConfiguration,
                shippingOptionConfiguration: cmsConfigurationStore.shippingConfigurationFormData
            }}
        />
    </>
})

export {
    CmsConfigurationPage
}
